import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4","key":"svg-0"}]]

const IconCornerDownLeft = createReactComponent('outline', 'corner-down-left', 'CornerDownLeft', __iconNode);

export default IconCornerDownLeft;